import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "w-full flex flex-col md:flex-row gap-4 bg-white p-6 my-3 rounded-md shadow-md" }
const _hoisted_3 = { class: "font-extrabold w-full md:w-9/12 text-neutral-900" }
const _hoisted_4 = { class: "w-full md:w-3/12 flex justify-end" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = ["initial", "enter"]
const _hoisted_7 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.questionCount) + ". " + _toDisplayString(_ctx.question.prompt), 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.playAudio)
          ? (_openBlock(), _createBlock(_component_MessageVoice, {
              key: 0,
              msg: _ctx.msgVoice(_ctx.question.prompt),
              scaleIcons: 0.8,
              showIconsName: false,
              onOnEndMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSpeak($event)))
            }, null, 8, ["msg", "scaleIcons"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question?.items, (item, i) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: i,
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion.getEnterMotion((i + 1) * 200),
          class: "bg-white flex items-center pl-3 my-3 gap-2 rounded-md shadow-md w-full"
        }, [
          _createVNode(_component_RadioButton, {
            inputId: item.id,
            name: "answer",
            value: item,
            disabled: _ctx.answers.isDisabled,
            modelValue: _ctx.answers.selected,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answers.selected) = $event)),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.chooseItem(_ctx.letter)), ["prevent"]))
          }, null, 8, ["inputId", "value", "disabled", "modelValue"]),
          _createElementVNode("label", {
            for: item.id,
            class: "cursor-pointer p-4 w-full"
          }, [
            _createElementVNode("p", null, [
              _createElementVNode("b", null, _toDisplayString(String.fromCharCode(i + 65)) + ".", 1),
              _createTextVNode(" " + _toDisplayString(item.answerText), 1)
            ])
          ], 8, _hoisted_7)
        ], 8, _hoisted_6)), [
          [_directive_motion]
        ])
      }), 128))
    ])
  ]))
}